import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Button } from "@mui/material";
import { Organization } from "@snubes/snubes-types";
import { FC, useState } from "react";
import { T } from "../../Translation/views/T";
import { useMyUser } from "../../Users/hooks/useMyUser";
import { InviteDialog } from "./InviteDialog";

// TODO WALZ: remove this once we have a proper email restriction.
export const RESTRICTED_ORG_IDS = [
  "8d58c663-18e6-477c-aa7e-d61267c77cdd", // prod Versandhaus Walz
  "e94e4401-a066-4b26-99f5-76e9d36ff7ed", // stg CoreLine
];
export const ALLOWED_EMAILS = [
  "a.weidlich@walz.de",
  "c.egle@walz.de",
  "p.huber@walz.de",
];

interface Props {
  organization: Organization;
  disabled?: boolean;
}

export const InviteButton: FC<Props> = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const userEmail = useMyUser((state) => state.user?.email);
  const userRole = useMyUser((state) => state.user?.role);

  // TODO WALZ: remove this once we have a proper email restriction.
  const isEmailRestricted =
    RESTRICTED_ORG_IDS.includes(props.organization.id) &&
    userRole !== "USER_ADMIN" &&
    (typeof userEmail !== "string" || !ALLOWED_EMAILS.includes(userEmail));

  const isDisabled = props.disabled || isEmailRestricted;

  return (
    <>
      <Button
        onClick={() => setIsDialogOpen(true)}
        variant="contained"
        disabled={isDisabled}
        startIcon={<AddCircleIcon />}
      >
        <T k="Invitation_Button_InviteNewMember" />
      </Button>

      {isDialogOpen && (
        <InviteDialog
          organization={props.organization}
          close={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
};
